export default __webpack_public_path__ + "static/media/DNo.26-6.0b1c0cfe.jpg";